"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ctorsUnion = exports.ctorsUnionWithTypeKey = void 0;
/**
 * To support currying, recursively wrap constructor functions as long as they
 * return other functions until an object is returned, then add type to that
 * object and return it.
 */
const wrapIt = (typeKey, key, fn) => (...args) => {
    const theReturn = fn(...args);
    return typeof theReturn === "function"
        ? wrapIt(typeKey, key, theReturn)
        : Object.assign({ [typeKey]: key }, theReturn);
};
/**
 * Create a union type from an object with constructor functions.
 */
function ctorsUnionWithTypeKey(typeKey, ctorsMap) {
    // Transform functions to add key as "type" property in constructed object
    const withType = Object.fromEntries(Object.entries(ctorsMap).map(([key, value]) => [
        key,
        wrapIt(typeKey, key, value),
    ]));
    return withType;
}
exports.ctorsUnionWithTypeKey = ctorsUnionWithTypeKey;
/**
 * Shortcut to use "type" as type-key
 */
const ctorsUnion = (ctorsMap) => ctorsUnionWithTypeKey("type", ctorsMap);
exports.ctorsUnion = ctorsUnion;
//# sourceMappingURL=ctors-union.js.map